export const MEDIA_LIMIT = {
  MAX_IMAGE: 10,
  MAX_VIDEO: 10,
  MAX_IMAGE_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_VIDEO_SIZE: 100 * 1024 * 1024, // 100MB
}
